import { render, staticRenderFns } from "./OrderLogisticsOld.vue?vue&type=template&id=a538df04&scoped=true"
import script from "./OrderLogisticsOld.vue?vue&type=script&lang=js"
export * from "./OrderLogisticsOld.vue?vue&type=script&lang=js"
import style0 from "./OrderLogisticsOld.vue?vue&type=style&index=0&id=a538df04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a538df04",
  null
  
)

export default component.exports